export const RUN_MODE = process.env.NEXT_PUBLIC_RUN_MODE
